import {
  inject,
  Provider,
  provideEnvironmentInitializer,
  EnvironmentProviders,
} from '@angular/core';
import { Store } from '@softline/core';
import { SOFTLINE_FEATURE_TRANSLATION, TranslationStore } from '@softline/ui-core';
import { default as de } from '../../i18n/de.json';
import { SOFTLINE_CONFIG_LOGIN_LINKS } from '@softapps/core/login';

export const portalRegistrationProviders: (Provider | EnvironmentProviders)[] = [
  provideEnvironmentInitializer(() => {
    const store = inject(Store);
    store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
      module: 'portalRegistration',
      language: 'de',
      translations: de,
    });
  }),
  {
    provide: SOFTLINE_CONFIG_LOGIN_LINKS,
    useValue: { name: '#PORTAL_REGISTRATION.TITLE', route: ['/registration'] },
    multi: true,
  },
];
